export type LoadFailure = (string) => void;

/*
 * Service loadFailure
 */
angular
  .module('posApp')
  .factory('loadFailure', ($window, $log, domain, translate) => {
    return function loadFailure(message) {
      const $translate = translate;

      if (!message) {
        message = $translate.instant('ThereWasAnError');
      } else {
        message = $translate.instant(message);
      }

      $log.error(message);

      // If there is a load failure, send the user back to www
      $window.location.href = domain.link(
        `www#/home?error=${encodeURIComponent(message)}`,
      );
    };
  });
